import { compareCompetitive, competeScore, competitiveBasis } from "../../lib/competitiveSort";

export function CompetitiveReadingNote({ results }) {
  const scored = (results || []).filter((r) => competeScore(r) != null);
  if (scored.length === 0) return null;
  const top = [...scored].sort(compareCompetitive)[0];
  const score = competeScore(top);
  const tied = scored.filter((r) => r !== top && competeScore(r) === score).length;
  return (
    <div
      data-testid="buckets-sort-competitive-reading"
      className="mb-3 rounded-md border border-stone-200 bg-white px-3 py-2 text-[12px] text-stone-700 leading-snug"
    >
      <span className="font-mono font-semibold text-stone-800">Reading this list:</span>{" "}
      sorted by one number, the <span className="italic">Compete</span> score (0–100, how selective the
      course is in general). It is not your personal chance, your grade gap or a league-table position.{" "}
      <span data-testid="buckets-sort-competitive-top">
        <span className="font-semibold">{top.university_name}</span>
        {top.degree_name ? ` – ${top.degree_name}` : ""} is first with Compete{" "}
        <span className="font-mono font-semibold">{Math.round(score * 100)}</span>, based on {competitiveBasis(top)}.
      </span>
      {tied > 0 && (
        <span data-testid="buckets-sort-competitive-ties">
          {" "}{tied} other course{tied === 1 ? " has" : "s have"} the same score; ties go to the lower
          offer rate, then university and course name A → Z.
        </span>
      )}
    </div>
  );
}
